import { render, staticRenderFns } from "./ExtraInfo.vue?vue&type=template&id=22846683&scoped=true"
import script from "./ExtraInfo.vue?vue&type=script&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&lang=js"
import style0 from "./ExtraInfo.vue?vue&type=style&index=0&id=22846683&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22846683",
  null
  
)

export default component.exports